<template>
  <div class="modal fade" id="add-admins" tabindex="-1" aria-hidden="true">
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal-simple modal-upgrade-plan"
    >
      <div class="modal-content">
        <div class="modal-body">
          <LoadingElement v-if="loading" />

          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            id="add-admins-close"
            aria-label="Close"
          ></button>
          <div class="bs-stepper wizard-vertical-icons-example mt-2">
            <div class="bs-stepper-header">
              <div
                @click.prevent="goStep(1)"
                class="step"
                role="button"
                data-target="#general-info"
              >
                <button type="button" class="step-trigger">
                  <span class="bs-stepper-circle">
                    <i class="ti ti-user"></i>
                  </span>
                  <span class="bs-stepper-label">
                    <span class="bs-stepper-title">{{
                      $t("admins.general_info")
                    }}</span>
                    <span class="bs-stepper-subtitle">{{
                      $t("admins.add_general_info")
                    }}</span>
                  </span>
                </button>
              </div>
              <div class="line"></div>
              <div
                @click.prevent="goStep(2)"
                class="step"
                role="button"
                data-target="#profile-details"
              >
                <button type="button" class="step-trigger">
                  <span class="bs-stepper-circle">
                    <i class="ti ti-network"></i>
                  </span>
                  <span class="bs-stepper-label">
                    <span class="bs-stepper-title">{{
                      $t("admins.network_details")
                    }}</span>
                    <span class="bs-stepper-subtitle">{{
                      $t("admins.setup_network_details")
                    }}</span>
                  </span>
                </button>
              </div>
              <div class="line"></div>
              <div
                @click.prevent="goStep(3)"
                class="step"
                role="button"
                data-target="#other-info"
              >
                <button type="button" class="step-trigger">
                  <span class="bs-stepper-circle"
                    ><i class="ti ti-adjustments-cog"></i>
                  </span>
                  <span class="bs-stepper-label">
                    <span class="bs-stepper-title">{{
                      $t("admins.privileges")
                    }}</span>
                    <span class="bs-stepper-subtitle">{{
                      $t("admins.choose_privileges")
                    }}</span>
                  </span>
                </button>
              </div>
            </div>
            <div class="bs-stepper-content">
              <form onSubmit="return false">
                <!-- general Info -->
                <div id="general-info" class="content">
                  <div class="row g-6">
                    <div class="col-12">
                      <div
                        class="d-flex align-items-start align-items-sm-center gap-6"
                      >
                        <img
                          v-if="currentImageUrl"
                          :src="currentImageUrl"
                          alt="user-avatar"
                          class="d-block w-px-100 h-px-100 rounded"
                          id="uploadedAvatar"
                        />
                        <img
                          src="@/assets/img/avatars/1.png"
                          v-if="!currentImageUrl"
                          alt="user-avatar"
                          class="d-block w-px-100 h-px-100 rounded"
                          id="uploadedAvatar"
                        />
                        <div class="button-wrapper">
                          <label
                            for="upload_user"
                            class="btn btn-primary me-3 mb-4"
                            tabindex="0"
                          >
                            <span class="d-none d-sm-block">{{
                              $t("admins.upload_new_photo")
                            }}</span>
                            <i class="ti ti-upload d-block d-sm-none"></i>
                            <input
                              type="file"
                              class="account-file-input"
                              id="upload_user"
                              hidden
                              ref="imageFile"
                              @change="selectImage"
                              accept="image/png, image/jpeg"
                            />
                          </label>
                          <button
                            type="button"
                            class="btn btn-label-secondary account-image-reset mb-4"
                          >
                            <i class="ti ti-refresh-dot d-block d-sm-none"></i>
                            <span class="d-none d-sm-block">{{
                              $t("admins.reset")
                            }}</span>
                          </button>

                          <div>{{ $t("admins.allowed_jpg_png_max_2M") }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <label class="form-label" for="">{{
                        $t("admins.first_name")
                      }}</label>
                      <input
                        type="text"
                        v-model="admin.first_name"
                        @input="validate"
                        class="form-control"
                        aria-describedby="basic-addon34"
                        :placeholder="$t('admins.first_name')"
                        :class="{ 'is-invalid': errors.first_name }"
                      />
                      <div v-if="errors.first_name" class="invalid-feedback">
                        {{ errors.first_name }}
                      </div>
                    </div>
                    <div class="col-md-6">
                      <label class="form-label" for="">{{
                        $t("admins.last_name")
                      }}</label>
                      <input
                        type="text"
                        class="form-control"
                        aria-describedby="basic-addon34"
                        :placeholder="$t('admins.last_name')"
                        v-model="admin.last_name"
                        @input="validate"
                        :class="{ 'is-invalid': errors.last_name }"
                      />
                      <div v-if="errors.last_name" class="invalid-feedback">
                        {{ errors.last_name }}
                      </div>
                    </div>
                    <div class="col-md-6">
                      <label class="form-label" for="">{{
                        $t("admins.email")
                      }}</label>
                      <input
                        type="text"
                        class="form-control"
                        autocomplete="one-time-code"
                        :placeholder="$t('admins.email')"
                        dir="auto"
                        v-model="admin.email"
                        oninput="this.value=this.value.replace(/[^a-zA-Z0-9_.@-\s]/g,'');"
                        @input="validate"
                        :class="{ 'is-invalid': errors.email }"
                      />
                      <div v-if="errors.email" class="invalid-feedback">
                        {{ errors.email }}
                      </div>
                    </div>
                    <div class="col-md-6">
                      <label class="form-label">{{ $t("admins.phone") }}</label>
                      <div class="input-group input-group-merge">
                        <input
                          type="text"
                          class="form-control"
                          autocomplete="one-time-code"
                          :placeholder="$t('admins.phone')"
                          dir="auto"
                          v-model="admin.phone"
                        />
                      </div>
                    </div>
                    <div class="col-12">
                      <label class="form-label">{{
                        $t("admins.password")
                      }}</label>
                      <div class="input-group input-group-merge">
                        <input
                          type="password"
                          class="form-control"
                          autocomplete="one-time-code"
                          :placeholder="admin.id ? 'No change' : '********'"
                          :class="{
                            'is-invalid': errors.password && !admin.id,
                          }"
                          v-model="admin.password"
                          aria-describedby="basic-default-password"
                        />
                        <div v-if="errors.password" class="invalid-feedback">
                          {{ errors.password }}
                        </div>
                      </div>
                    </div>

                    <div class="col-12 d-flex justify-content-between">
                      <button class="btn btn-label-secondary btn-prev" disabled>
                        <i class="ti ti-arrow-left ti-xs me-sm-2"></i>
                        <span class="align-middle d-sm-inline-block d-none">{{
                          $t("control.previous")
                        }}</span>
                      </button>
                      <button
                        @click.prevent="nextStep"
                        class="btn btn-primary btn-next"
                      >
                        <span
                          class="align-middle d-sm-inline-block d-none me-sm-2"
                          >{{ $t("control.next") }}</span
                        >
                        <i class="ti ti-arrow-right ti-xs"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <!-- Network Details -->
                <div id="profile-details" class="content">
                  <div class="row g-6">
                    <div class="col-md-12">
                      <!-- <label for="flatpickr-datetime" class="form-label">{{
                        $t("admins.allowed_nases")
                      }}</label> -->
                      <!-- <div class="select2-primary">
                        <multiselect
                          v-model="admin.allowed_nases"
                          :options="nases"
                          :close-on-select="false"
                          :trackBy="'value'"
                          :label="'label'"
                          :searchable="false"
                          :taggable="true"
                          :multiple="true"
                          :hideSelected="true"
                        ></multiselect>
                      </div> -->
                      <h5 class="card-header m-0">
                        <div class="d-inline-block">
                          <input
                            type="checkbox"
                            @input="checkAll(nases, admin.allowed_nases)"
                            v-model="admin.allowed_nases.checkAll"
                            class="form-check-input"
                          />
                        </div>
                        <label for=""
                          ><h4 class="mx-1 my-4">
                            {{ $t("admins.allowed_nases") }}
                          </h4></label
                        >
                      </h5>
                      <hr class="m-0" />
                      <div class="row gap-y-5 gap-x-0 mt-1">
                        <div
                          class="col-12 col-md-4"
                          v-for="(nas, index) in nases"
                          :key="index"
                          v-memo="[admin.allowed_nases.length]"
                        >
                          <input
                            type="checkbox"
                            class="form-check-input"
                            :name="nas.value"
                            :id="nas.value"
                            :value="nas"
                            v-model="admin.allowed_nases"
                          />
                          <label :for="nas.value">{{ nas.label }}</label>
                        </div>
                      </div>
                    </div>
                    <div
                      class="col-md-12"
                      v-if="hasPrivilege('admins_assign_profiles')"
                    >
                      <!-- <label for="flatpickr-datetime" class="form-label">{{
                        $t("nases.allowed_profiles")
                      }}</label> -->
                      <!-- <div class="select2-primary">
                        <multiselect
                          v-model="admin.allowed_profiles"
                          :options="profiles"
                          :close-on-select="false"
                          :trackBy="'value'"
                          :label="'label'"
                          :searchable="false"
                          :taggable="true"
                          :multiple="true"
                          :hideSelected="true"
                        ></multiselect>
                      </div> -->
                      <h5 class="card-header m-0">
                        <div class="d-inline-block">
                          <input
                            type="checkbox"
                            @input="checkAll(profiles, admin.allowed_profiles)"
                            v-model="admin.allowed_profiles.checkAll"
                            class="form-check-input"
                          />
                        </div>
                        <label for=""
                          ><h4 class="mx-1 my-4">
                            {{ $t("nases.allowed_profiles") }}
                          </h4></label
                        >
                      </h5>
                      <hr class="m-0" />
                      <div class="row gap-y-5 gap-x-0 mt-1">
                        <div
                          class="col-12 col-md-4"
                          v-for="(profile, index) in profiles"
                          :key="index"
                          v-memo="[admin.allowed_profiles.length]"
                        >
                          <input
                            type="checkbox"
                            class="form-check-input"
                            :name="profile.value"
                            :id="profile.value"
                            :value="profile"
                            v-model="admin.allowed_profiles"
                          />
                          <label :for="profile.value">{{
                            profile.label
                          }}</label>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <label class="form-label">{{
                        $t("admins.custom_network_name")
                      }}</label>
                      <input
                        type="text"
                        v-model="admin.custom_network_name"
                        class="form-control"
                        aria-describedby="basic-addon34"
                        :placeholder="
                          admin.custom_network_name ? '' : $t('control.default')
                        "
                      />
                    </div>
                    <div
                      class="col-md-6"
                      v-if="hasPrivilege('admins_custom_network_logo')"
                    >
                      <div
                        class="d-flex align-items-start align-items-sm-center gap-6 mt-3 mb-3"
                      >
                        <img
                          v-if="currentLogoUrl"
                          :src="currentLogoUrl"
                          alt="user-avatar"
                          class="d-block w-px-100"
                          id="uploadedAvatar"
                        />
                        <div class="button-wrapper">
                          <label
                            for="upload_logo"
                            class="btn btn-primary btn-sm me-3 mb-2"
                            tabindex="0"
                          >
                            <span class="d-none d-sm-block">{{
                              $t("admins.upload_new_photo")
                            }}</span>
                            <i class="ti ti-upload d-block d-sm-none"></i>
                            <input
                              type="file"
                              id="upload_logo"
                              class="account-file-input"
                              ref="logoFile"
                              @change="selectLogo"
                              hidden
                              accept="image/png, image/jpeg"
                            />
                          </label>
                          <div>{{ $t("admins.custom_network_logo") }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div
                        class="d-flex align-items-start align-items-sm-center gap-6 mt-3 mb-3"
                      >
                        <img
                          v-if="currentSignatureUrl"
                          :src="currentSignatureUrl"
                          alt="user-avatar"
                          class="d-block w-px-100"
                        />
                        <div class="button-wrapper">
                          <label
                            for="upload_sign"
                            class="btn btn-primary btn-sm me-3 mb-2"
                            tabindex="0"
                          >
                            <span class="d-none d-sm-block">{{
                              $t("admins.upload_new_photo")
                            }}</span>
                            <i class="ti ti-upload d-block d-sm-none"></i>
                            <input
                              type="file"
                              class="account-file-input"
                              ref="signatureFile"
                              @change="selectSignature"
                              id="upload_sign"
                              hidden
                              accept="image/png, image/jpeg"
                            />
                          </label>
                          <div>{{ $t("admins.signature") }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 d-flex justify-content-between">
                      <button
                        @click.prevent="previousStep"
                        class="btn btn-label-secondary btn-prev"
                      >
                        <i class="ti ti-arrow-left ti-xs me-sm-2"></i>
                        <span class="align-middle d-sm-inline-block d-none">{{
                          $t("control.previous")
                        }}</span>
                      </button>
                      <button
                        @click.prevent="nextStep"
                        class="btn btn-primary btn-next"
                      >
                        <span
                          class="align-middle d-sm-inline-block d-none me-sm-2"
                          >{{ $t("control.next") }}</span
                        >
                        <i class="ti ti-arrow-right ti-xs"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <!-- Social Links -->
                <div id="other-info" class="content">
                  <div class="col-sm-6">
                    <label class="form-label" for="country1">{{
                      $t("admins.privileges_group")
                    }}</label>
                    <select
                      class="form-select"
                      v-model="admin.privileges_group_id"
                    >
                      <option
                        v-for="(group, index) in privilege_groups"
                        :key="index"
                        :value="group.id"
                        >{{ group.name }}
                      </option>
                      <option :value="null"
                        >={{ $t("groups.custom_privileges") }}=</option
                      >
                    </select>
                  </div>
                  <div v-if="admin.privileges_group_id == null">
                    <div class="mb-6">
                      <h5 class="card-header">
                        <div class="d-inline-block">
                          <input
                            type="checkbox"
                            @input="selectAllAll()"
                            v-model="privileges.selected"
                            class="form-check-input"
                          />
                        </div>
                        <label for=""
                          ><h4 class="mx-1">
                            {{ $t("nases.privileges") }}
                          </h4></label
                        >
                      </h5>
                      <hr class="m-0" />
                    </div>
                    <div
                      v-for="(privilege_group, index) in privileges"
                      :key="index"
                    >
                      <div class="mb-6">
                        <h5 class="card-header m-0">
                          <div class="d-inline-block">
                            <input
                              type="checkbox"
                              @input="selectAllPrivileges(privilege_group)"
                              v-model="privilege_group.selected"
                              class="form-check-input"
                            />
                          </div>
                          <label for=""
                            ><h4 class="mx-1 my-4">
                              {{ privilege_group.label }}
                            </h4></label
                          >
                        </h5>
                        <hr class="m-0" />
                        <div class="row gap-y-5 gap-x-0 mt-1">
                          <div
                            class="col-12 col-md-4"
                            v-for="(privilege,
                            index) in privilege_group.children"
                            :key="index"
                            v-memo="privilege_group.children"
                          >
                            <input
                              type="checkbox"
                              class="form-check-input"
                              :name="privilege.id"
                              :id="privilege.id"
                              v-model="privilege.selected"
                            />
                            <label :for="privilege.id">{{
                              privilege.label
                            }}</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 d-flex justify-content-between mt-7">
                    <button
                      @click.prevent="previousStep"
                      class="btn btn-label-secondary btn-prev"
                    >
                      <i class="ti ti-arrow-left ti-xs me-sm-2"></i>
                      <span class="align-middle d-sm-inline-block d-none">{{
                        $t("control.previous")
                      }}</span>
                    </button>
                    <button
                      class="btn btn-success"
                      @click.prevent="store"
                      :disabled="!validated"
                    >
                      {{ this.admin.id ? $t("admins.save") : $t("admins.add") }}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters, mapState } from "vuex";
import { hasPrivilege } from "../../global_constants";
import LoadingModal from "./loading-modal.vue";
export default {
  name: "AddAdmin",
  computed: {
    ...mapGetters(["user", "settings"]),
  },
  props: {
    editProfile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      error: "",
      message: "",
      error_message: "",
      currentImageUrl: null,
      currentLogoUrl: null,
      currentSignatureUrl: null,
      loading: false,
      admin: {
        first_name: "",
        last_name: "",
        phone: null,
        profile_image: "",
        email: "",
        password: "",
        privileges: [],
        allowed_nases: [],
        allowed_profiles: [],
        type: "admin",
        money: "-1",
        prefix: "",
        custom_network_logo: "",
        custom_network_name: "",
        selected_privileges: [],
        signature: "",
        privileges_group_id: null,
      },
      privilege_groups: [],
      profiles: [],
      nases: [],
      privileges: [],
      options: [
        {
          id: 0,
          label: "All",
          isDefaultExpanded: true,
          children: null,
        },
      ],
      errors: {
        first_name: null,
        last_name: null,
        email: null,
        password: null,
      },
      validated: false,
      stepper: null,
      server_url: localStorage.getItem("server"),
    };
  },
  async created() {
    this.loading = true;
    await this.fetchNases();
    await this.fetchProfiles();
    if (
      this.$route.query.type == "resellers" ||
      this.admin.type == "reseller"
    ) {
      const response = await axios.get("resellers/privileges");
      this.privileges = response.data;
      this.loading = false;
      this.admin.type = "reseller";
      if (this.admin.money == -1) this.admin.money = "0";
    } else {
      const response = await axios.get("admins/privileges");
      this.privileges = response.data;
      this.loading = false;
    }
    if (this.$route.query.admin_id) {
      await this.fetchAdmin();
      if (this.admin.profile_image) {
        this.currentImageUrl = this.server_url + this.admin.profile_image;
      }
      if (this.admin.custom_network_logo) {
        this.currentLogoUrl = this.server_url + this.admin.custom_network_logo;
      }
      if (this.admin.signature) {
        this.currentSignatureUrl = this.server_url + this.admin.signature;
      }
      this.validate();
    } else {
      var temp = [];
      this.nases.forEach((element) => {
        temp.push(element);
      });
      this.admin.allowed_nases = temp;
      this.admin.allowed_nases.checkAll = true;
      temp = [];
      this.profiles.forEach((element) => {
        temp.push(element);
      });
      this.admin.allowed_profiles = temp;
      this.admin.allowed_profiles.checkAll = true;
    }
    await this.fetchPrivilgesGroups();
    if (this.$route.query.operation == "copy") {
      this.admin.id = null;
      this.admin.first_name = "";
      this.admin.last_name = "";
      this.admin.email = "";
      this.admin.password = "";
      this.admin.phone = "";
    }
  },
  mounted() {
    this.stepper = new Stepper(document.querySelector(".bs-stepper"), {
      linear: true,
      animation: false,
      selectors: {
        steps: ".step",
        trigger: ".step-trigger",
        stepper: ".bs-stepper",
      },
    });
  },
  methods: {
    nextStep() {
      this.stepper.next();
    },
    previousStep() {
      this.stepper.previous();
    },
    goStep(num) {
      this.stepper.to(num);
    },
    hasPrivilege(privilege) {
      return hasPrivilege(this.user, privilege);
    },
    selectImage() {
      this.admin.profile_image = this.$refs.imageFile.files.item(0);
      this.currentImageUrl = URL.createObjectURL(this.admin.profile_image);
    },
    selectLogo() {
      this.admin.custom_network_logo = this.$refs.logoFile.files.item(0);
      this.currentLogoUrl = URL.createObjectURL(this.admin.custom_network_logo);
    },
    selectSignature() {
      this.admin.signature = this.$refs.signatureFile.files.item(0);
      this.currentSignatureUrl = URL.createObjectURL(this.admin.signature);
    },
    async fetchAdmin() {
      this.loading = true;
      const response = await axios.get(`admins/${this.$route.query.admin_id}`);
      if (response.status == 200) {
        this.admin = response.data.data;
        var temp = [];
        if (this.admin.allowed_nases) {
          this.admin.allowed_nases.forEach((element) => {
            temp.push({ value: element.id, label: element.shortname });
          });
          this.admin.allowed_nases = temp;
        }
        if (this.admin.allowed_profiles) {
          temp = [];
          this.admin.allowed_profiles.forEach((element) => {
            temp.push({ value: element.id, label: element.name });
          });
          this.admin.allowed_profiles = temp;
        }
        this.privileges.forEach((privilege_group) => {
          privilege_group.children.forEach((privilege) => {
            if (this.admin.privileges.find((str) => str === privilege.id))
              privilege.selected = true;
          });
        });
      }
      this.loading = false;
    },
    async fetchNases() {
      const response = await axios.get("nases?itr=true&rows=10000000");
      response.data.data.forEach((element) => {
        this.nases.push({ value: element.id, label: element.shortname });
      });
    },
    async fetchProfiles() {
      const response = await axios.get("profiles?itr=true&rows=10000000");
      response.data.data.forEach((element) => {
        this.profiles.push({ value: element.id, label: element.name });
      });
    },
    async fetchPrivilgesGroups() {
      const response = await axios.get("groups/names?type=admins");
      if (response.status == 200) {
        this.privilege_groups = response.data.data;
        if (this.admin.id == null && this.privilege_groups.length > 0)
          this.admin.privileges_group_id = this.privilege_groups[0].id;
      }
    },
    checkAll(data, model) {
      if (!model.checkAll) {
        data.forEach((element) => {
          model.push(element);
        });
      } else {
        model.splice(0, model.length);
      }
    },
    selectAllAll() {
      if (this.privileges.selected) {
        this.privileges.forEach((group) => {
          group.selected = false;
          group.children.forEach((privilege, index) => {
            group.children[index].selected = false;
          });
        });
      } else {
        this.privileges.forEach((group) => {
          group.selected = true;
          group.children.forEach((privilege, index) => {
            group.children[index].selected = true;
          });
        });
      }
    },
    selectAllPrivileges(group) {
      if (group.selected) {
        group.children.forEach((privilege, index) => {
          group.children[index].selected = false;
        });
      } else {
        group.children.forEach((privilege, index) => {
          group.children[index].selected = true;
        });
      }
    },
    async store() {
      this.loading = true;
      this.admin.privileges = [];
      this.privileges.forEach((privilege_group) => {
        privilege_group.children.forEach((privilege) => {
          if (privilege.selected) this.admin.privileges.push(privilege.id);
        });
      });
      console.log(this.admin.privileges);

      if (this.admin.id) {
        var data = new FormData();
        if (this.admin.profile_image)
          data.append("profile_image", this.admin.profile_image);
        if (this.admin.custom_network_logo)
          data.append("custom_network_logo", this.admin.custom_network_logo);
        data.append("signature", this.admin.signature);
        data.append("first_name", this.admin.first_name);
        data.append("last_name", this.admin.last_name);
        if (this.admin.phone) data.append("phone", this.admin.phone);
        data.append("email", this.admin.email);
        data.append("password", this.admin.password);
        data.append("type", this.admin.type);
        if (this.admin.money) data.append("money", this.admin.money);
        if (this.admin.prefix) data.append("prefix", this.admin.prefix);
        if (this.admin.custom_network_name)
          data.append("custom_network_name", this.admin.custom_network_name);
        if (this.admin.privileges_group_id)
          data.append("privileges_group_id", this.admin.privileges_group_id);
        if (this.admin.privileges_group_id == null) {
          for (let i = 0; i < this.admin.privileges.length; i++) {
            data.append("privileges[]", this.admin.privileges[i]);
          }
        }
        for (let i = 0; i < this.admin.allowed_nases.length; i++) {
          data.append("allowed_nases[]", this.admin.allowed_nases[i].value);
        }
        for (let i = 0; i < this.admin.allowed_profiles.length; i++) {
          data.append(
            "allowed_profiles[]",
            this.admin.allowed_profiles[i].value,
          );
        }
        var response = await axios.post(`/admins/${this.admin.id}`, data, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      } else {
        var data = new FormData();
        if (this.admin.profile_image)
          data.append("profile_image", this.admin.profile_image);
        data.append("first_name", this.admin.first_name);
        data.append("last_name", this.admin.last_name);
        if (this.admin.phone) data.append("phone", this.admin.phone);
        data.append("email", this.admin.email);
        data.append("password", this.admin.password);
        data.append("type", this.admin.type);
        if (this.admin.money) data.append("money", this.admin.money);
        if (this.admin.prefix) data.append("prefix", this.admin.prefix);
        if (this.admin.privileges_group_id)
          data.append("privileges_group_id", this.admin.privileges_group_id);
        if (this.admin.privileges_group_id == null) {
          for (let i = 0; i < this.admin.privileges.length; i++) {
            data.append("privileges[]", this.admin.privileges[i]);
          }
        }
        for (let i = 0; i < this.admin.allowed_nases.length; i++) {
          data.append("allowed_nases[]", this.admin.allowed_nases[i].value);
        }
        for (let i = 0; i < this.admin.allowed_profiles.length; i++) {
          data.append(
            "allowed_profiles[]",
            this.admin.allowed_profiles[i].value,
          );
        }
        var response = await axios.post("/admins", data, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      }

      if (response.status == 200) {
        this.loading = false;
        if (this.admin.type == "reseller") {
          document.getElementById("add-admins-close").click();
          this.$notify({
            text: this.$t("messages.reseller_updated_successfully"),
            type: "success",
          });
          this.$emit("updated");
        } else {
          document.getElementById("add-admins-close").click();
          this.$notify({
            text: this.$t("messages.admin_updated_successfully"),
            type: "success",
          });
          this.$emit("updated");
        }
      } else if (response.status == 210) {
        this.loading = false;
        this.errors.email = this.$t("errors.admins.username_taken");
        this.validated = false;
        window.scrollTo(0, 0);
      } else if (response.status == 211) {
        this.error_message = this.$t(`errors.license.${response.data.error}`);
        this.validated = false;
        this.loading = false;
      }
    },
    // async loadOptions({ action, parentNode, callback }) {
    //   this.loading = true;
    //   if (action === LOAD_CHILDREN_OPTIONS) {
    //     switch (parentNode.id) {
    //       case 0:
    //         const response = await axios.get("admins/privileges");
    //         parentNode.children = response.data;
    //         callback();
    //         break;
    //       default:
    //         break;
    //     }
    //   }
    //   this.loading = false;
    // },
    validate() {
      this.validated = true;
      this.errors.email = null;
      this.errors.password = null;
      this.errors.first_name = null;
      this.errors.last_name = null;
      if (this.admin.email.length < 3) {
        this.validated = false;
        this.errors.email = this.$t("errors.admins.username_3");
      }
      if (this.admin.first_name.length < 1) {
        this.validated = false;
        this.errors.first_name = this.$t("errors.admins.first_name");
      }
      if (this.admin.last_name.length < 1) {
        this.validated = false;
        this.errors.last_name = this.$t("errors.admins.last_name");
      }
      // if (!this.admin.password) this.admin.password = "1";
      // if (
      //   this.admin.password.length < 3 &&
      //   !this.admin.id &&
      //   !this.$route.params.id
      // ) {
      //   this.validated = false;
      //   this.errors.password = this.$t("errors.admins.password_3");
      // }
    },
    selectAll() {
      this.admin.privileges = [];
      this.privileges.forEach((element) => {
        element.children.forEach((privilege) => {
          this.admin.privileges.push(privilege.id);
        });
      });
    },
  },
};
</script>
